// extracted by mini-css-extract-plugin
export var actionIcon = "_uy-0";